import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {IntranetoldService} from '../../../api/intranetold.service'
import { Columns, Config, DefaultConfig, APIDefinition, API } from 'ngx-easy-table';
import {DocumentoMarketingDetalle, DocumentoMarting, Lote} from "../../../model/ventaModel"
import Swal from 'sweetalert2'
import {variableGlobal} from "../../../global.enum";



@Component({
  selector: 'app-abreTablaGenerico',
  templateUrl: './abreTablaGenerico.html',
  styleUrls: ['./query-mongo.component.sass']
})
export class abreTablaGenericoComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private _api: IntranetoldService
  ) { }

  @ViewChild('table', { static: true }) table: APIDefinition;
  @ViewChild('frmSelect', { static: true }) frmSelect: TemplateRef<any>;
  @ViewChild('frmFecha', { static: true }) frmFecha: TemplateRef<any>;
  public configuration: Config;
  public columns: Columns[];
  columnsCopy: Columns[] = [];
  data:any = [];
  query:string;
  titulo:string;
  // Permite forzar columnas y agregar botón de selección (mejor UX)
  @Input() presetColumns?: Columns[];
  @Input() allowSelectBtn: boolean = false;
  ngOnInit(): void {

    this.cargaInicial();
  }


  async cargaInicial()
  {


    this.columns = [];

    const dato:any = await this._api.GetNotFileQuery(this.query);
    

    if (dato.estado) {
      this.data = dato.objeto || [];

      // Columnas: si el llamador envía presetColumns, usarlas; si no, autogenerar si hay datos
      if (this.allowSelectBtn) {
        this.columns.push({ key: '__select__', title: '', width: '70px', cellTemplate: this.frmSelect, searchEnabled: false, orderEnabled: false });
      }

      if (this.presetColumns && this.presetColumns.length) {
        this.columns.push(...this.presetColumns);
      } else if (this.data.length > 0) {
        const arregloNombre = Object.keys(this.data[0]);
        arregloNombre.forEach(element => {
          this.columns.push({ key: element, title: element });
        });
      }

      // Aplicar template de fecha si existe columna DocDate
      this.columns = this.columns.map(col => {
        if (col.key === 'DocDate') {
          return { ...col, cellTemplate: this.frmFecha } as Columns;
        }
        return col;
      });

      if (this.data.length === 0) {
        Swal.fire('Sin resultados', 'No se encontraron registros para la búsqueda.', 'info');
      }

      this.configuration = {
        ...DefaultConfig,
        searchEnabled: true,
        detailsTemplate: true,
        paginationRangeEnabled: true,
        paginationEnabled: true,
        horizontalScroll: true,
        resizeColumn: true,
        orderEnabled: false,
        rowReorder: false,
        columnReorder: false,
        fixedColumnWidth: true,
      };
    } else {
      Swal.fire('Mensaje', dato.mensaje || 'Error al ejecutar la consulta', 'error');
      this.data = [];
    }

    if(variableGlobal.ESTILO_EASY_TABLE)
    {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }
  }

  private setClass(name: string): void {
    this.table.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }

  cerrar() {
    this.activeModal.close();
  }

  // Permite seleccionar una fila con doble click y retornar el registro al llamador
  eventEmitted($event: { event: string; value: any }): void {
    try {
      if ($event && $event.event === 'onDoubleClick') {
        const row = $event.value?.row;
        if (row) {
          this.activeModal.close(row);
        }
      }
    } catch {}
  }

  seleccionar(row: any) {
    if (row) {
      this.activeModal.close(row);
    }
  }






}
